/**
 * Initialization of the Swiper for the Grid
 */
const initGridSwiper = () => {
    const swiperContainers = document.querySelectorAll('.lit-grid-swiper');

    swiperContainers.forEach(container => {
        // Avoid double initialization
        if (container.classList.contains('swiper-initialized')) return;

        if (typeof Swiper !== 'undefined') {
            const swiper = new Swiper(container, {
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: false,
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: container.querySelector('.swiper-button-next'),
                    prevEl: container.querySelector('.swiper-button-prev'),
                },
                breakpoints: {
                    // Mobile: 1 slide only (< 768px)
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        centeredSlides: false,
                    },
                    // Tablet: 2 complete slides (768px - 1023px)
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        centeredSlides: false,
                    },
                    // Desktop: 4 slides (>= 1024px)
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                        centeredSlides: false,
                    }
                }
            });

            // Add class to mark as initialized
            container.classList.add('swiper-initialized');

            // Hover effect with gradient mask
            const cards = container.querySelectorAll('.lit-grid-card');
            cards.forEach(card => {
                const glow = card.querySelector('.lit-grid-card-glow');

                card.addEventListener('mousemove', (e) => {
                    const rect = card.getBoundingClientRect();
                    const y = e.clientY - rect.top;

                    if (glow) {
                        glow.style.maskImage = `radial-gradient(circle at 0px ${y}px, rgb(255, 255, 255) 0%, rgba(0, 0, 0, 0) 100%)`;
                        glow.style.webkitMaskImage = `radial-gradient(circle at 0px ${y}px, rgb(255, 255, 255) 0%, rgba(0, 0, 0, 0) 100%)`;
                    }
                });
            });
        }
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGridSwiper);
} else {
    initGridSwiper();
}
